import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./AppShell.js";
import { RequireSignedIn } from "./RequireSignedIn.js";
import { RequireConsent } from "./RequireConsent.js";
import { SignedOutScreen } from "../screens/signedout/SignedOutScreen.js";
import { HomeScreen } from "../screens/home/HomeScreen.js";
import { GlobalTasksScreen } from "../screens/tasks/GlobalTasksScreen.js";
import { GlobalCalendarScreen } from "../screens/calendar/GlobalCalendarScreen.js";
import { DeletedItemsScreen } from "../screens/deleted/DeletedItemsScreen.js";
import { SubjectListScreen } from "../screens/subjects/SubjectListScreen.js";
import { SubjectLayout } from "../screens/subject/SubjectLayout.js";
import { SubjectOverviewTab } from "../screens/subject/SubjectOverviewTab.js";
import { SubjectTasksTab } from "../screens/subject/SubjectTasksTab.js";
import { SubjectCalendarTab } from "../screens/subject/SubjectCalendarTab.js";
import { SubjectMapTab } from "../screens/subject/SubjectMapTab.js";
import { ChapterLayout } from "../screens/subject/chapter/ChapterLayout.js";
import { ChapterOverviewTab } from "../screens/subject/chapter/ChapterOverviewTab.js";
import { ChapterMapTab } from "../screens/subject/chapter/ChapterMapTab.js";
import { ChapterTestsTab } from "../screens/subject/chapter/ChapterTestsTab.js";
import { AITestListScreen } from "../screens/subject/tests/AITestListScreen.js";
import { AITestEditorScreen } from "../screens/subject/tests/AITestEditorScreen.js";
import { TestAttemptScreen } from "../screens/subject/tests/TestAttemptScreen.js";
import { FreeTextMarkingScreen } from "../screens/subject/tests/FreeTextMarkingScreen.js";
import { ScoreReviewScreen } from "../screens/subject/tests/ScoreReviewScreen.js";
import { InventoryScreen } from "../screens/inventory/InventoryScreen.js";
import { LastViewedPageRedirect } from "./LastViewedPageRedirect.js";
import { AppOriginEntry } from "./AppOriginEntry.js";
import { GlobalTestsScreen } from "../screens/tests/GlobalTestsScreen.js";

export function AppRouter() {
  return (
    <Routes>
      {/* This origin has no landing page: the public site (apps/www) owns it,
          and "/" here is also MSAL's redirectUri. */}
      <Route path="/" element={<AppOriginEntry />} />
      <Route path="/login" element={<SignedOutScreen mode="login" />} />
      <Route path="/signed-out" element={<SignedOutScreen mode="signedOut" />} />
      <Route
        element={
          <RequireSignedIn>
            <RequireConsent>
              <AppShell />
            </RequireConsent>
          </RequireSignedIn>
        }
      >
        <Route path="home" element={<LastViewedPageRedirect />} />
        <Route path="dashboard" element={<HomeScreen />} />
        <Route path="tasks" element={<GlobalTasksScreen />} />
        <Route path="calendar" element={<GlobalCalendarScreen />} />
        <Route path="tests" element={<GlobalTestsScreen />} />
        <Route path="deleted" element={<DeletedItemsScreen />} />
        <Route path="inventory" element={<InventoryScreen />} />
        <Route path="subjects" element={<SubjectListScreen />} />
        <Route path="subjects/:subjectId" element={<SubjectLayout />}>
          <Route index element={<Navigate to="overview" replace />} />
          <Route path="map" element={<SubjectMapTab />} />
          <Route path="overview" element={<SubjectOverviewTab />} />
          <Route path="tasks" element={<SubjectTasksTab />} />
          <Route path="calendar" element={<SubjectCalendarTab />} />
          <Route path="tests" element={<AITestListScreen />} />
          <Route path="tests/:testId" element={<AITestEditorScreen />} />
          <Route path="tests/:testId/attempts/:attemptId" element={<TestAttemptScreen />} />
          <Route path="tests/:testId/attempts/:attemptId/mark" element={<FreeTextMarkingScreen />} />
          <Route path="tests/:testId/attempts/:attemptId/review" element={<ScoreReviewScreen />} />
        </Route>
        <Route path="subjects/:subjectId/chapters/:chapterId" element={<ChapterLayout />}>
          <Route index element={<Navigate to="overview" replace />} />
          <Route path="overview" element={<ChapterOverviewTab />} />
          <Route path="map" element={<ChapterMapTab />} />
          <Route path="tests" element={<ChapterTestsTab />} />
        </Route>
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Route>
    </Routes>
  );
}
